import { Component } from '@angular/core';

@Component({
  selector: 'app-discover',
  templateUrl: './discover.component.html',
  styleUrls: ['./discover.component.scss']
})
export class DiscoverComponent {
  openSameTab(ev: Event, href: string) {
    ev.preventDefault();                // evita navegação SPA
    window.location.assign(href);       // navega na mesma aba com reload
    // window.location.replace(href);   // se não quiser empilhar no histórico
  }

}
